<template>
  <Home />
  <Footer />
  <ImageVisualizer />
</template>

<style lang="scss" src="./scss/styles.scss"></style>
<script>
/**
 * Created : Slo 19.05.2021
 */
import Home from '@/components/Home'
import Footer from '@/components/Footer'
import ImageVisualizer from '@/components/ImageVisualizer'
export default {
  components: { ImageVisualizer, Footer, Home }
}
</script>
